import { render, staticRenderFns } from "./TableCellName.vue?vue&type=template&id=20945396&"
import script from "./TableCellName.vue?vue&type=script&lang=ts&"
export * from "./TableCellName.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports